import { render } from "./ForHiringCompanies.vue?vue&type=template&id=37d379a2"
import script from "./ForHiringCompanies.vue?vue&type=script&lang=js"
export * from "./ForHiringCompanies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__